import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    HostListener,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import {NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router} from '@angular/router';
import {ContractsUtils} from '../../lib/user/contracts/contracts.utils';
import * as pubsub from "pubsub-js"
import {ToastService} from '../../lib/services/toast/toast.service';
import {MenuService} from "../../lib/services/menu/menu.service";
import {BASELINK, command} from "../sidebar/menu";
import {TokenExpiredTimerService} from '../../lib/services/token-expired-timer/token-expired-timer.service';
import {UserUtilsService} from '../../lib/services/user/user-utils.service';
import {firstValueFrom, Subscription} from 'rxjs';
import {SidebarComponent} from '../sidebar/sidebar.component';
import {NotificationConnectionService} from '../../lib/services/notifications/notification-connection.service';
import {BulkPermissionsService, ContractService} from '@monex-sistemas/nueva-banca-digital-library';
import {NpsService} from "../../lib/services/nps/nps.service";
import {DashboardService} from '../../lib/services/dashboard/dashboard.service';
import {LoadingService} from '../../lib/services/loading/loading.service';
import {TranslateService} from '@ngx-translate/core';
import {PubsubEnum} from '../../lib/enums/pubsub.enum';
import {GeolocationService} from '../../lib/services/geolocation/geolocation.service'
import {StorageKeysEnum} from '../../lib/storage/storage-keys.enum';
import {PermissionService} from '../../lib/services/permission/permission.service';
import * as _ from "lodash";

@Component({
    selector: 'app-base',
    templateUrl: './base.component.html',
    styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild('app-sidebar') sidebar!: SidebarComponent
    globalLoading!: boolean;
    isLoading!: boolean;
    menuLoaded!: boolean;
    contractSelected: any
    fullContractSelected: any
    subItems: any[] = []
    subItemId: number | null = null
    isMobile: boolean = false
    itemsPerSlide: number = 4
    indexSlide: number = -1
    showProgressSpinner: boolean = false
    contracts: any
    permission: boolean = false;
    isDashboard: boolean = false
    routerSubscription!: Subscription;

    constructor(
        private contractUtils: ContractsUtils,
        private router: Router,
        private toastService: ToastService,
        private menuService: MenuService,
        private translateService: TranslateService,
        private tokenExpiredTimerService: TokenExpiredTimerService,
        private userInfo: UserUtilsService,
        private notificationConnectionService: NotificationConnectionService,
        private contractService: ContractService,
        public npsService: NpsService,
        private dashboardService: DashboardService,
        private loadingService: LoadingService,
        private permissionService: PermissionService,
        private geolocationService: GeolocationService,
        private bulkPermissionsService: BulkPermissionsService,
        private userUtilsService: UserUtilsService,
        private cdr : ChangeDetectorRef
    ) {
        // Spinner for lazyload modules
        router.events.forEach((event) => {
            if (event instanceof RouteConfigLoadStart) {
                this.isLoading = true;
            } else if (event instanceof RouteConfigLoadEnd) {
                this.isLoading = false;
            }
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
        this.checkIfMobile();
    }

    private checkIfMobile(): void {
        let maxItemPerSlide = 4
        const windowWidth = window.innerWidth
        if (windowWidth < 990) this.isMobile = true
        if (windowWidth < 600) {
            maxItemPerSlide = 1
        } else if (windowWidth > 600 && windowWidth < 800) {
            maxItemPerSlide = 2
        } else if (windowWidth > 800 && windowWidth < 989) {
            maxItemPerSlide = 3
        } else {
            this.isMobile = false
            maxItemPerSlide = 4
        }

        this.itemsPerSlide = this.subItems.length > maxItemPerSlide ? maxItemPerSlide : this.subItems.length

    }

    async ngOnInit(): Promise<void> {
        await this.getUserPermissions()
        this.setInitialValues();
        this.connectToWebsocket();
        await this.getAllDashboardContracts();
        await this.buildMenu();
        this.checkIfDashboardRoute()
        this.settingSubmenu()
        this.checkIfMobile()
        this.verifyGeolocationEvent()
        this.subscribeToRouter();
        this.subscribePubsubEvents();
        this.indexSlide = this.subItems.findIndex(x => x.id == this.userInfo.getUserInfoSessionStorage().subMenuId)
        this.cdr.detectChanges()
        // this.subItems = this.userInfo.getUserInfoSessionStorage().subMenu ?? []
        this.checkPermission(this.userInfo.getUserInfoSessionStorage().subMenu)
    }

    setInitialValues() {
        this.contractSelected = this.userInfo.getContractUserSelected()
        this.fullContractSelected = this.userInfo.getUserContractInfoSessionStorage()
        this.permission = this.bulkPermissionsService.hasBulkActionPermission(this.fullContractSelected);
        this.contracts = this.contractUtils.getContractsByServices();
    }


    subscribeToRouter() {
        this.routerSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.checkIfDashboardRoute()
            }
        });
    }

    subscribePubsubEvents() {
        pubsub.subscribe("toast", (msg: any, data: any) => {
            this.toastService.showToast(data.message, data.type, data.summary)
        });
        pubsub.subscribe("contract", async (msg: any, data: any) => {
            this.contractSelected = data?.idContrato
            this.fullContractSelected = data
            this.contracts = this.contractUtils.getContractsByServices();
            await this.buildMenu();
            this.checkPermission(this.userInfo.getUserInfoSessionStorage().subMenu)
        })

        pubsub.subscribe("PROGRESS_SPINNER", (msg: any, data: any) => {
            this.showProgressSpinner = data
        })

        pubsub.subscribe("rowMenu", (msg: any, data: any) => {
            this.subItems = data.subItems ?? []
            this.checkPermission(data.subItems)
            this.subItemId = data.subId
            this.userInfo.setUserInfoSessionStorage({subMenu: this.subItems, subMenuId: data.subId})
            this.indexSlide = this.subItems.findIndex(x => x.id == data.subId)
            this.checkIfMobile()
        })
        this.cdr.detectChanges()
    }

    trackByItems(index: number, item: any): number {
        return item.id
    }

    async getUserPermissions() {
        let res
        try {
            res = await firstValueFrom(this.permissionService.getAllPermissionsInContract())
        } catch (error) {
            console.log(error);
            return
        }
        sessionStorage.setItem(StorageKeysEnum.PERMISSIONS, JSON.stringify(res))
    }

    checkPermission(subItems: any[]) {
        this.subItems = [];
        for (const item of subItems) {
            if (!item.requirePermission) {
                this.subItems.push(item)
            }
            if (
                item.requirePermission &&
                this.contractService.checkPermissionNumberInContract(11, this.contractSelected) &&
                this.userInfo.getUserInfoSessionStorage().perJuridicaTitular === "PM"
            ) this.subItems.push(item)
        }
        this.validateNominaPermission()
        //console.log(this.subItems)
    }

    validateNominaPermission() {
        const isNomina = this.fullContractSelected.nomina;
        if (isNomina) {
            this.subItems = _.filter(this.subItems, item => item.id != 1024);
        }
    }

    async getAllDashboardContracts(): Promise<any> {
        this.loadingService.show()
        let res
        try {
            res = await firstValueFrom(this.dashboardService.getAllContracts());
            this.contractUtils.completeContractsInformation(res.contracts);
            this.dashboardService.setContracts(res)
            this.loadingService.hide()
        } catch (error) {
            console.log(error);
            this.loadingService.hide()
            const msg = await firstValueFrom(this.translateService.get("CONTRACT_ERROR_GET"))
            this.toastService.showToast(msg, "error", "Error");
            return;
        }
    }


    checkIfDashboardRoute() {
        this.isDashboard = this.router.url.includes("dashboard")
    }

    async buildMenu() {

        let res
        this.globalLoading = true;
        try {
            res = await firstValueFrom(this.menuService.getMenu(this.contractSelected))
        } catch (error) {
            console.error(error)
            this.globalLoading = false;
            this.menuLoaded = true;
        }

        this.globalLoading = false;
        this.menuLoaded = true;

        let url = this.router.url;
        url = url.replace(BASELINK, '');
        this.menuService.validateMenu(url);
    }

    navigateTo(item: any, index: number) {
        this.userInfo.setUserInfoSessionStorage({subMenuId: item.id})
        this.subItemId = item.id
        this.indexSlide = index
        this.checkIfMobile()
        this.router.navigate([item.routerLink])
    }

    slideRangeChange(event: any) {

    }
    activeSlide(event: any){
        this.indexSlide = event
    }

    settingSubmenu() {
        const info = this.userInfo.getUserInfoSessionStorage();
        this.subItemId = info.subMenuId
        if (!info.subMenuId) {
            const subId = command(0).subId
            this.subItems = command(0).subItems
            this.userInfo.setUserInfoSessionStorage({subMenu: this.subItems, subMenuId: subId})
        } else {
            this.subItems = info.subMenu
        }
    }

    async connectToWebsocket() {
        await this.notificationConnectionService.connectToWebsocket()
        this.notificationConnectionService.sendPing()
    }

    ngOnDestroy(): void {
        pubsub.clearAllSubscriptions()
    }

    verifyGeolocationEvent() {
        pubsub.subscribe(PubsubEnum.GEOLOCATION_NOT_ALLOWED_EVENT, () => {
            const geolocationModalContainerDiv = document.getElementById("geolocationModalContainer")
            if (!geolocationModalContainerDiv) {
                this.geolocationService.showGeolocationModal()
            }
        })
    }


    ngAfterViewInit() {
        pubsub.subscribe("rowMenu", (msg: any, data: any) => {
            this.subItems = data.subItems ?? []
            this.subItemId = data.subId
            setTimeout(()=>{
                this.indexSlide = this.subItems.findIndex(x => x.id == data.subId);
            },100)
        })
    }
}
